import TopicTag from './TopicTag'

export default TopicTag
